export default {
  white: "white",
  blue: "rgb(0, 123, 255)",
  red: "#d9534f",
  blueTransparent: "rgb(0, 123, 255, .2)",
  green: "rgb(40, 167, 69)",
  greenTransparent: "rgba(40, 167, 69, .2)"
}
